import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { Table, Thead, Tr, Th } from "commons";

export class RegularTable extends PureComponent {
    render() {
        if (this.props.rows === undefined || this.props.rows.length === 0) {
            return <div />;
        }

        return (
            <Table>
                <Thead>
                    <Tr>
                        <Th align="left" colSpan={5}>
                            {this.props.title}
                        </Th>
                    </Tr>
                </Thead>
                <Thead>
                    <Tr>
                        <Th align="left">Type</Th>
                        <Th align="left">Amount</Th>
                        <Th align="left">Frequency</Th>
                        <Th align="left">{this.props.nextHeader}</Th>
                        <Th align="left">Bank details</Th>
                    </Tr>
                </Thead>
                <tbody>{this.props.rows}</tbody>
            </Table>
        );
    }
}

RegularTable.propTypes = {
    rows: PropTypes.node,
    title: PropTypes.string,
    nextHeader: PropTypes.string
};
